<template>
  <div class="XXZX">
    <div class="title">
      <span>消息中心</span>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 16px;
        margin-bottom: 10px;
      "
    >
      <div class="nav">
        <span :class="{ selectNav: selectOption == 0 }" @click="checkNav(0)"
          >全部消息</span
        >
        <span :class="{ selectNav: selectOption == 1 }" @click="checkNav(1)"
          >项目咨询</span
        >
        <span :class="{ selectNav: selectOption == 2 }" @click="checkNav(2)"
          >政策资讯</span
        >
        <span :class="{ selectNav: selectOption == 3 }" @click="checkNav(3)"
          >投诉</span
        >
      </div>
      <!-- <div style="display: flex;align-items: center;cursor: pointer;" v-if="this.showList.length">
                <img src="@/assets/img/clear.png" style="width: 20px;height: 20px;">
                <span
                    style="font-size: 17px;font-family: Source Han Sans CN-Regular, Source Han Sans CN;font-weight: 400;color: #6681EA;">一键已读</span>
            </div> -->
    </div>
    <div v-if="showList.length" style="min-height: 700px">
      <div v-for="(data, index) in showList" :key="index" class="list">
        <div class="left">
          <span v-if="data.status == 0" class="redDot"></span>
          <span class="title1">{{ data.title }}</span>
        </div>
        <div class="right">
          <span class="read" @click="look(data)">查看</span>
        </div>
      </div>
      <div class="operation">
        <span
          style="
            font-size: 18px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
          "
          >共 {{ totalNumber }} 页</span
        >
        <div class="pageNumber" @click="showPageNum">
          <span
            style="
              font-size: 18px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              margin-right: 34px;
            "
            >{{ pageNumber }}条/页</span
          >
          <i
            class="el-icon-arrow-up"
            style="font-size: 14px"
            v-if="showCheckPageNumber"
          ></i>
          <i class="el-icon-arrow-down" style="font-size: 14px" v-else></i>
          <div class="pageNum" v-if="showCheckPageNumber">
            <span @click="checkPageNum(10)">10条/页</span>
            <span @click="checkPageNum(20)">20条/页</span>
            <span @click="checkPageNum(30)">30条/页</span>
            <span @click="checkPageNum(50)">50条/页</span>
          </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="checkPage"
          layout=" prev, pager, next, jumper"
          :total="totalNumber"
          :page-size="pageNumber"
        >
        </el-pagination>
      </div>
    </div>
    <div
      v-else
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        height: 700px;
      "
    >
      <img src="@/assets/img/empty.png" style="width: 286px; height: 228px" />
    </div>

    <el-dialog :visible.sync="open" width="700px" style="zoom: 1.25">
      <div class="lookTitle">{{ lookForm.title }}</div>
      <div class="lookTime">时间:{{ lookForm.createTime }}</div>
      <div class="lookMsg">咨询内容：{{ lookForm.content }}</div>
      <div>
        <span style="font-size: 18px">回复列表：</span>
        <div style="border-bottom: 1px dashed #ddd; margin-top: 10px"></div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px 10px;
            border-bottom: 1px dashed #ddd;
          "
          v-for="(item, index) in replyList"
          :key="index"
        >
          <span
            style="
              font-size: 18px;
              max-width: 400px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
            >{{ item.message }}</span
          >
          <span style="font-size: 16px">{{
            item.updateTime ? item.updateTime : item.createTime
          }}</span>
          <!-- <button class="detailBtn" @click="showDetail(index)">详情</button> -->
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="open1" width="700px">
      <div style="display: flex; align-items: center; flex-direction: column">
        <h1>{{ lookForm.title }}</h1>
        <span style="font-size: 18px; margin: 16px 0"
          >回复时间：{{
            replyDetail.updateTime
              ? replyDetail.updateTime
              : replyDetail.createTime
          }}</span
        >
        <div style="text-align: start; width: 70%">
          <span style="font-size: 20px"
            >回复内容：{{ replyDetail.message }}</span
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { messageList, msgList, msgListByRefId, msgReadByRefId } from "../../api/mian.js"
import { getUserInfoByUserId } from "../../api/login.js"

export default {
  data () {
    return {
      // 全部消息列表
      mainList: [],
      // 项目消息列表
      projectList: [],
      // 系统消息列表
      systemList: [],
      // 选中展示列表
      showList: [

      ],
      // 选中导航栏
      selectOption: 0,// 	1、项目咨询 2、政策咨询 3、投诉
      // 当前查看页数
      checkPage: 1,
      // 一页展示条数
      pageNumber: 10,
      // 全部条数
      totalNumber: 20,
      // 是否展示选择每页展示条数下拉框
      showCheckPageNumber: false,
      userId: null,
      // 回复消息列表弹窗
      open: false,
      // 回复消息详情弹窗
      open1: false,
      lookForm: {

      },
      // 回复列表
      replyList: [],
      // 回复详情
      replyDetail: {}
    }
  },
  created () {
    getUserInfoByUserId().then(res => {
      this.userId = res.data.data.userId

    }).then(() => {
      this.getMessageList()
    })
  },
  methods: {
    showDetail (i) {
      this.replyDetail = this.replyList[i]
      this.open1 = true
    },
    // 消息查看
    look (data) {
      msgListByRefId({ refId: data.id }).then(res => {
        console.log('回复详情', res)
        this.lookForm = res.data.data.advise
        this.replyList = res.data.data.msgList
        this.open = true
        // msgReadByRefId()
      })
    },
    checkNav (nav) {
      this.selectOption = nav
      this.getMessageList()
    },
    // 翻页事件
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.checkPage = val

      this.getMessageList()
    },
    // 选择页数事件
    showPageNum () {
      this.showCheckPageNumber = !this.showCheckPageNumber
    },
    checkPageNum (num) {
      this.pageNumber = num
      this.getMessageList()

    },

    getMessageList () {
      let obj = this.selectOption == 0 ? {
        pageNum: this.checkPage,
        pageSize: this.pageNumber,
      } : {
        pageNum: this.checkPage,
        pageSize: this.pageNumber,
        type: this.selectOption,
      }
      msgList(obj).then(res => {
        console.log(res.data)
        this.totalNumber = res.data.total
        this.showList = res.data.rows
      })
    },
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.XXZX {
  box-shadow: 0px 0px 25px 4px rgba(90, 90, 90, 0.12);
  padding: 24px 30px;
  display: flex;
  flex-direction: column;
}

.title {
  padding-bottom: 20px;
  font-size: 30px;
  color: #6681ea;
  border-bottom: 1px solid #6681ea;
}

.nav {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #616161;
}

.nav > span {
  margin-right: 20px;
  cursor: pointer;
}

.selectNav {
  color: #6681ea;
}

.list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0 10px;
  border-bottom: 1px solid #c0c4cc;
}

.left {
  display: flex;
  align-items: center;
}

.redDot {
  width: 10px !important;
  height: 10px !important;
  background-color: red;
  border-radius: 100px;
  margin-right: 10px;
}

.title1 {
  font-size: 20px;
  width: 800px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.right {
  display: flex;
  cursor: pointer;
}

.read {
  padding: 4px 10px;
  border: 1px solid #6681ea;
  border-radius: 5px;
  font-size: 18px;
  color: #6681ea;
}

.operation {
  display: flex;
  align-items: center;
  justify-content: right;
  margin-top: 30px;
}

.pageNumber {
  padding: 4px 10px;
  border: 1px solid #c0c4cc;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin: 0 12px;
  position: relative;
}

.pageNum {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 100%;
  left: 0;
  background-color: #fff;
  border-radius: 10px;
  z-index: 10000;
  width: 100%;
  user-select: none;
  border: 1px solid #ddd;
}

.pageNum > span {
  padding: 6px 10px;
  font-size: 18px;
  font-weight: 400;
  cursor: pointer;
  border-bottom: 1px #ddd solid;
}

.pageNum > span:hover {
  padding: 6px 10px;
  font-size: 18px;
  font-weight: 400;
  cursor: pointer;
  border-bottom: 1px #ddd solid;
  background-color: #eee;
}

.el-pagination {
  display: flex;
}

.lookTitle {
  width: 100%;
  height: 30px;
  text-align: center;
  font-size: 20px;
}

.lookTime {
  width: 100%;
  text-align: right;
  margin-bottom: 20px;
}

.lookMsg {
  width: 100%;
  height: auto;
  font-size: 18px;
  text-indent: 2em;
  padding-bottom: 40px;
}

.detailBtn {
  border: 1px solid #5d9fff;
  border-radius: 10px;
  background-color: #5d9fff;
  font-size: 16px;
  color: #fff;
  padding: 6px 14px;
  cursor: pointer;
  user-select: none;
}
</style>